// import React, { useState } from "react";
// import { nigeriaStates, workTypes } from "../../assets/jobData";
// import { toast } from "sonner";
// import qs from "query-string";
// import { useNavigate } from "react-router-dom";

// const SearchBox = () => {
//   const [searchParams, setSearchParams] = useState("job");
//   const [formData, setFormData] = useState({});
//   const navigate = useNavigate();

//   const handleSelection = (e, selection) => {
//     e.preventDefault();
//     setSearchParams(selection);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleFind = (e) => {
//     e.preventDefault();

//     const { jobTitle, workType, state } = formData;

//     if (!jobTitle && !workType && !state) {
//       return toast.error("Kindly fill the search fields");
//     }

//     const queryParams = {
//       ...(jobTitle && { jobTitle }),
//       ...(state && { state }),
//       ...(workType && { workType }),
//       searchType: searchParams,
//     };

//     const queryString = qs.stringify(queryParams);
//     if (searchParams === "job") {
//       navigate(`/jobs?${queryString}`);
//       return;
//     }
//     if (searchParams === "candidate") {
//       navigate(`/candidate?${queryString}`);
//       return;
//     }
//   };

//   return (
//     <div className="mt-20">
//       <div className="flex flex-col items-center gap-8 mt-24 text-center text-white">
//         <h1 className="text-4xl font-bold">
//           The Easiest Way To Get Your New Job
//         </h1>
//         <h3 className="text-xl">
//           Search 270 new jobs.{" "}
//           <span className="text-lg">0 added in the last 24 hours</span>
//         </h3>

//         <form className="flex flex-col items-center gap-4 w-full sm:w-3/5 p-6 rounded-lg shadow-lg">
        
// <div className="flex flex-col items-center gap-4 w-full sm:w-3/5 p-6 rounded-lg shadow-lg">
//   <div className="flex mb-1 gap-1">
//     <button
//       onClick={(e) => {
//         handleSelection(e, "job");
//       }}
//       className={`px-4 py-2 text-white hover:bg-orange-600 ${
//         searchParams === "job"
//           ? "bg-orange-500"
//           : "bg-white-500 border-[2px]"
//       } transition-colors`}
//     >
//       FIND A JOB
//     </button>
//     <button
//       onClick={(e) => {
//         handleSelection(e, "candidate");
//       }}
//       className={`px-4 py-2 text-white hover:bg-orange-600 ${
//         searchParams === "candidate"
//           ? "bg-orange-500"
//           : "bg-white-500 border-[2px]"
//       } transition-colors`}
//     >
//       FIND A CANDIDATE
//     </button>
//   </div>

//   <div className="w-full md:flex md:flex-row md:gap-4">
//     <input
//       className="p-2 mb-4 text-gray-600 w-full border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors md:w-1/2 md:mb-0"
//       type="text"
//       placeholder="e.g., Web Developer"
//       onChange={handleChange}
//       name="jobTitle"
//       id="jobTitle"
//     />

//     <div className="flex flex-row gap-4 w-full md:w-1/2">
//       <select
//         onChange={handleChange}
//            className="p-2 mb-4 w-full text-gray-600 border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors md:flex-1 md:mb-0"
//         name="workType"
//         id="workType"
//       >
//         <option value="">Category</option>
//         {workTypes &&
//           workTypes.map((eachType, index) => (
//             <option key={index} value={eachType}>
//               {eachType}
//             </option>
//           ))}
//       </select>

//       <select
//         onChange={handleChange}
//         className="p-2 text-gray-600 mb-4 w-full border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors md:w-1/2 md:mb-0"
//         name="state"
//         id="state"
//       >
//         <option value="">State</option>
//         {nigeriaStates &&
//           nigeriaStates.map((eachState, index) => (
//             <option key={index} value={eachState}>
//               {eachState}
//             </option>
//           ))}
//       </select>
//     </div>
//   </div>

//   <button
//     onClick={handleFind}
//     className="bg-orange-500 px-6 py-2 text-white rounded-md hover:bg-orange-600 transition-colors"
//   >
//     Search
//   </button>
// </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default SearchBox;







































// import React, { useState, useEffect } from "react";
// import { nigeriaStates, workTypes } from "../../assets/jobData";
// import { toast } from "sonner";
// import qs from "query-string";
// import { useNavigate } from "react-router-dom";
// import { useFetchData } from "../../hooks/useFtechData";


// const SearchBox = () => {
//   const [searchParams, setSearchParams] = useState("job");
//   const [formData, setFormData] = useState({});
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const navigate = useNavigate();

//   // Fetch jobseekers when searching by name
//   const { data: jobseekers, loading: jobseekersLoading } = useFetchData(
//     formData.jobseekerName && searchParams === "candidate"
//       ? `${process.env.REACT_APP_API_URL}jobSeeker/allJobSeeker?name=${formData.jobseekerName}`
//       : null
//   );

//   const handleSelection = (e, selection) => {
//     e.preventDefault();
//     setSearchParams(selection);
//     setFormData({}); // Reset form data when switching search type
//     setIsModalOpen(false); // Close modal when switching
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//     if (name === "jobseekerName" && value && searchParams === "candidate") {
//       setIsModalOpen(true); // Open modal when typing in jobseeker name
//     } else {
//       setIsModalOpen(false); // Close modal if input is cleared
//     }
//   };

//   const handleFind = (e) => {
//     e.preventDefault();

//     const { jobTitle, workType, state, jobseekerName } = formData;

//     if (!jobTitle && !workType && !state && !jobseekerName) {
//       return toast.error("Kindly fill at least one search field");
//     }

//     const queryParams = {
//       ...(jobTitle && { jobTitle }),
//       ...(state && { state }),
//       ...(workType && { workType }),
//       ...(jobseekerName && { jobseekerName }),
//       searchType: searchParams,
//     };

//     const queryString = qs.stringify(queryParams);
//     if (searchParams === "job") {
//       navigate(`/jobs?${queryString}`);
//       return;
//     }
//     if (searchParams === "candidate") {
//       navigate(`/candidate?${queryString}`);
//       setIsModalOpen(false); // Close modal on search
//       return;
//     }
//   };

//   const handleJobseekerSelect = (jobseekerId) => {
//     navigate(`/profile/${jobseekerId}`);
//     setIsModalOpen(false);
//     setFormData({}); // Clear form after selection
//   };

//   return (
//     <div className="mt-20">
//       <div className="flex flex-col items-center gap-8 mt-24 text-center text-white">
//         <h1 className="text-4xl font-bold">
//           The Easiest Way To Get Your New Job
//         </h1>
//         <h3 className="text-xl">
//           Search 270 new jobs.{" "}
//           <span className="text-lg">0 added in the last 24 hours</span>
//         </h3>

//         <form className="flex flex-col items-center gap-4 w-full sm:w-3/5 p-6 rounded-lg shadow-lg">
//           <div className="flex flex-col items-center gap-4 w-full sm:w-3/5 p-6 rounded-lg shadow-lg">
//             <div className="flex mb-1 gap-1">
//               <button
//                 onClick={(e) => {
//                   handleSelection(e, "job");
//                 }}
//                 className={`px-4 py-2 text-white hover:bg-orange-600 ${
//                   searchParams === "job"
//                     ? "bg-orange-500"
//                     : "bg-white-500 border-[2px]"
//                 } transition-colors`}
//               >
//                 FIND A JOB
//               </button>
//               <button
//                 onClick={(e) => {
//                   handleSelection(e, "candidate");
//                 }}
//                 className={`px-4 py-2 text-white hover:bg-orange-600 ${
//                   searchParams === "candidate"
//                     ? "bg-orange-500"
//                     : "bg-white-500 border-[2px]"
//                 } transition-colors`}
//               >
//                 FIND A CANDIDATE
//               </button>
//             </div>

//             <div className="w-full md:flex md:flex-row md:gap-4 relative">
//               <input
//                 className="p-2 mb-4 text-gray-600 w-full border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors md:w-1/2 md:mb-0"
//                 type="text"
//                 placeholder={searchParams === "job" ? "e.g., Web Developer" : "e.g., John Doe"}
//                 onChange={handleChange}
//                 name={searchParams === "job" ? "jobTitle" : "jobseekerName"}
//                 id={searchParams === "job" ? "jobTitle" : "jobseekerName"}
//                 value={formData[searchParams === "job" ? "jobTitle" : "jobseekerName"] || ""}
//               />

//               {isModalOpen && searchParams === "candidate" && (
//                 <div className="absolute top-full left-0 mt-2 w-full md:w-1/2 bg-white rounded-lg shadow-lg z-10 max-h-64 overflow-y-auto">
//                   {jobseekersLoading ? (
//                     <div className="p-4 text-gray-600">Loading...</div>
//                   ) : jobseekers?.length > 0 ? (
//                     jobseekers.map((jobseeker) => (
//                       <div
//                         key={jobseeker._id}
//                         onClick={() => handleJobseekerSelect(jobseeker._id)}
//                         className="p-4 text-gray-900 hover:bg-orange-100 cursor-pointer border-b border-gray-200"
//                       >
//                         {jobseeker.firstName} {jobseeker.middleName || ""} {jobseeker.lastName}
//                       </div>
//                     ))
//                   ) : (
//                     <div className="p-4 text-gray-600">No jobseekers found</div>
//                   )}
//                 </div>
//               )}

//               <div className="flex flex-row gap-4 w-full md:w-1/2">
//                 <select
//                   onChange={handleChange}
//                   className="p-2 mb-4 w-full text-gray-600 border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors md:flex-1 md:mb-0"
//                   name="workType"
//                   id="workType"
//                   value={formData.workType || ""}
//                 >
//                   <option value="">Category</option>
//                   {workTypes &&
//                     workTypes.map((eachType, index) => (
//                       <option key={index} value={eachType}>
//                         {eachType}
//                       </option>
//                     ))}
//                 </select>

//                 <select
//                   onChange={handleChange}
//                   className="p-2 text-gray-600 mb-4 w-full border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors md:w-1/2 md:mb-0"
//                   name="state"
//                   id="state"
//                   value={formData.state || ""}
//                 >
//                   <option value="">State</option>
//                   {nigeriaStates &&
//                     nigeriaStates.map((eachState, index) => (
//                       <option key={index} value={eachState}>
//                         {eachState}
//                       </option>
//                     ))}
//                 </select>
//               </div>
//             </div>

//             <button
//               onClick={handleFind}
//               className="bg-orange-500 px-6 py-2 text-white rounded-md hover:bg-orange-600 transition-colors"
//             >
//               Search
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default SearchBox;



































import React, { useState, useEffect } from "react";
import { nigeriaStates, workTypes } from "../../assets/jobData";
import { toast } from "sonner";
import qs from "query-string";
import { useNavigate } from "react-router-dom";
import { useFetchData } from "../../hooks/useFtechData";

// Simulated Paystack payment function (replace with actual Paystack integration)
const initiatePaystackPayment = () => {
  return new Promise((resolve) => {
    // Simulate Paystack payment success after 2 seconds
    setTimeout(() => resolve({ status: "success", transactionId: "TXN123456" }), 2000);
  });
};

const SearchBox = () => {
  const [searchParams, setSearchParams] = useState("job");
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const navigate = useNavigate();

  // Fetch jobseekers when searching by name
  const { data: jobseekers, loading: jobseekersLoading } = useFetchData(
    formData.jobseekerName && searchParams === "candidate"
      ? `${process.env.REACT_APP_API_URL}jobSeeker/allJobSeeker?name=${formData.jobseekerName}`
      : null
  );

  const handleSelection = (e, selection) => {
    e.preventDefault();
    setSearchParams(selection);
    setFormData({}); // Reset form data when switching search type
    setIsModalOpen(false); // Close modal when switching
    setShowMoreDetails(false); // Reset details view
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === "jobseekerName" && value && searchParams === "candidate") {
      setIsModalOpen(true); // Open modal when typing in jobseeker name
    } else {
      setIsModalOpen(false); // Close modal if input is cleared
    }
  };

  const handleFind = async (e) => {
    e.preventDefault();

    const { jobTitle, workType, state, city, jobseekerName } = formData;

    if (!jobTitle && !workType && !state && !city && !jobseekerName) {
      return toast.error("Kindly fill at least one search field");
    }

    const queryParams = {
      ...(jobTitle && { jobTitle }),
      ...(state && { state }),
      ...(city && { city }),
      ...(workType && { workType }),
      ...(jobseekerName && { jobseekerName }),
      searchType: searchParams,
    };

    const queryString = qs.stringify(queryParams);
    if (searchParams === "job") {
      navigate(`/jobs?${queryString}`);
      return;
    }
    if (searchParams === "candidate") {
      navigate(`/candidate?${queryString}`);
      setIsModalOpen(false); // Close modal on search
      return;
    }
  };

  const handleJobseekerSelect = (jobseekerId) => {
    navigate(`/profile/${jobseekerId}`);
    setIsModalOpen(false);
    setFormData({}); // Clear form after selection
  };

  const handleViewMore = async (jobseekerId) => {
    try {
      const paymentResult = await initiatePaystackPayment();
      if (paymentResult.status === "success") {
        setShowMoreDetails(true); // Show more details after payment
        toast.success("Payment successful! View more details below.");
        // Navigate to a detailed view or display additional data (simulated here)
        console.log(`Viewing more details for jobseeker ${jobseekerId}`);
      }
    } catch (error) {
      toast.error("Payment failed. Please try again.");
    }
  };

  return (
    <div className="mt-20">
      <div className="flex flex-col items-center gap-8 mt-24 text-center text-white">
        <h1 className="text-4xl font-bold">
          The Easiest Way To Get Your New Job
        </h1>
        <h3 className="text-xl">
          Search 270 new jobs.{" "}
          <span className="text-lg">0 added in the last 24 hours</span>
        </h3>

        <form className="flex flex-col items-center gap-4 w-full sm:w-3/5 p-6 rounded-lg shadow-lg">
          <div className="flex mb-1 gap-1">
            <button
              onClick={(e) => handleSelection(e, "job")}
              className={`px-4 py-2 text-white hover:bg-green-600 ${
                searchParams === "job"
                  ? "bg-green-500"
                  : "bg-white-500 border-[2px]"
              } transition-colors`}
            >
              FIND A JOB
            </button>
            <button
              onClick={(e) => handleSelection(e, "candidate")}
              className={`px-4 py-2 text-white hover:bg-green-600 ${
                searchParams === "candidate"
                  ? "bg-green-500"
                  : "bg-white-500 border-[2px]"
              } transition-colors`}
            >
              FIND A CANDIDATE
            </button>
          </div>

          <div className="w-full md:flex md:flex-row md:items-center md:gap-4 relative">
            {/* Desktop-specific layout */}
            <div className="hidden md:flex md:flex-row md:items-center md:w-full md:gap-4 p-4 bg-white rounded-lg shadow-lg">
              <div className="flex-1 p-2">
                <input
                  className="p-2 w-full border-none outline-none text-gray-600 placeholder-gray-400"
                  type="text"
                  placeholder={searchParams === "job" ? "e.g., Web Developer" : "e.g., John Doe"}
                  onChange={handleChange}
                  name={searchParams === "job" ? "jobTitle" : "jobseekerName"}
                  id={searchParams === "job" ? "jobTitle" : "jobseekerName"}
                  value={formData[searchParams === "job" ? "jobTitle" : "jobseekerName"] || ""}
                />
              </div>
              <div className="flex-1 p-2">
                <select
                  onChange={handleChange}
                  className="p-2 w-full border-none outline-none text-gray-600 bg-transparent"
                  name="workType"
                  id="workType"
                  value={formData.workType || ""}
                >
                  <option value="">Category</option>
                  {workTypes &&
                    workTypes.map((eachType, index) => (
                      <option key={index} value={eachType}>
                        {eachType}
                      </option>
                    ))}
                </select>
              </div>
              <div className="flex-1 p-2">
                <select
                  onChange={handleChange}
                  className="p-2 w-full border-none outline-none text-gray-600 bg-transparent"
                  name="state"
                  id="state"
                  value={formData.state || ""}
                >
                  <option value="">State</option>
                  {nigeriaStates &&
                    nigeriaStates.map((eachState, index) => (
                      <option key={index} value={eachState}>
                        {eachState}
                      </option>
                    ))}
                </select>
              </div>
              {formData.state && (
                <div className="flex-1 p-2">
                
                    <input
                  className="p-2 w-full border-none outline-none text-gray-600 placeholder-gray-400"
                  type="text"
                placeholder='city (optional)'
                  onChange={handleChange}
                   name="city"
                    id="city"
                  value={formData.city || ""}
                />
                
                </div>
              )}
              <button
                onClick={handleFind}
                className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 transition-colors"
              >
                Search
              </button>
            </div>

            {/* Mobile layout (unchanged) */}
            <div className="md:hidden flex flex-col items-center gap-4 w-full">
              <input
                className="p-2 mb-4 text-gray-600 w-full border-2 border-gray-300 rounded-md outline-none focus:border-green-500 transition-colors"
                type="text"
                placeholder={searchParams === "job" ? "e.g., Web Developer" : "e.g., John Doe"}
                onChange={handleChange}
                name={searchParams === "job" ? "jobTitle" : "jobseekerName"}
                id={searchParams === "job" ? "jobTitle" : "jobseekerName"}
                value={formData[searchParams === "job" ? "jobTitle" : "jobseekerName"] || ""}
              />

              {isModalOpen && searchParams === "candidate" && (
                <div className="absolute top-full left-0 mt-2 w-full bg-white rounded-lg shadow-lg z-10 max-h-64 overflow-y-auto">
                  {jobseekersLoading ? (
                    <div className="p-4 text-gray-600">Loading...</div>
                  ) : jobseekers?.length > 0 ? (
                    jobseekers.map((jobseeker) => (
                      <div
                        key={jobseeker._id}
                        className="p-4 text-gray-900 border-b border-gray-200 flex justify-between items-center"
                      >
                        <span>
                          {jobseeker.firstName} {jobseeker.middleName || ""} {jobseeker.lastName}
                        </span>
                        <button
                          onClick={() => handleViewMore(jobseeker._id)}
                          className="text-blue-500 hover:text-blue-700 ml-4"
                        >
                          View More
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="p-4 text-gray-600">No jobseekers found</div>
                  )}
                  {showMoreDetails && (
                    <div className="p-4 text-gray-900 bg-gray-100 mt-2">
                      More details: Email: {jobseekers[0]?.email || "N/A"}, Phone: {jobseekers[0]?.phone || "N/A"}
                    </div>
                  )}
                </div>
              )}

              <div className="flex flex-row gap-4 w-full">
                <select
                  onChange={handleChange}
                  className="p-2 mb-4 w-full text-gray-600 border-2 border-gray-300 rounded-md outline-none focus:border-green-500 transition-colors"
                  name="workType"
                  id="workType"
                  value={formData.workType || ""}
                >
                  <option value="">Category</option>
                  {workTypes &&
                    workTypes.map((eachType, index) => (
                      <option key={index} value={eachType}>
                        {eachType}
                      </option>
                    ))}
                </select>

                <select
                  onChange={handleChange}
                  className="p-2 text-gray-600 mb-4 w-full border-2 border-gray-300 rounded-md outline-none focus:border-green-500 transition-colors"
                  name="state"
                  id="state"
                  value={formData.state || ""}
                >
                  <option value="">State</option>
                  {nigeriaStates &&
                    nigeriaStates.map((eachState, index) => (
                      <option key={index} value={eachState}>
                        {eachState}
                      </option>
                    ))}
                </select>
              </div>

              {formData.state && (
                <select
                  onChange={handleChange}
                  className="p-2 mb-4 w-full text-gray-600 border-2 border-gray-300 rounded-md outline-none focus:border-green-500 transition-colors"
                  name="city"
                  id="city"
                  value={formData.city || ""}
                >
                  <option value="">City (optional)</option>
                  {/* Example cities - replace with dynamic data if available */}
                  <option value="Lagos">Lagos</option>
                  <option value="Ibadan">Ibadan</option>
                  <option value="Abuja">Abuja</option>
                </select>
              )}

              <button
                onClick={handleFind}
                className="bg-green-500 px-6 py-2 text-white rounded-md hover:bg-green-600 transition-colors"
              >
                Search
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SearchBox;